import { render } from "./ReportModal.vue?vue&type=template&id=0ff6b49c"
import script from "./ReportModal.vue?vue&type=script&lang=js"
export * from "./ReportModal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__